<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date">运单号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.waybillNo"></span>
				</div>
			</div>
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date">手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone"></span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
        <div class="data-table-box">
			<common-table
				ref="CommonTableRef"
				:tableColumns="tableColumns"
				:data="dataList"
				:showPage="true"
				:loading="loading"

				:pageConfig="pageConfig"
				@selectionChange="selectionChange"
				@currentChange="currentChange"
				@sizeChange="sizeChange"
			>
			</common-table>
        </div>
	</div>
</template>
<script>
export default {
	name: 'WxRecord',
	props: [],
	components: {},
	data(){
		return{
            tableColumns:[{
                    key: 'createTimeFormatted',
					align:'center',
					width:'100',
                    title: '发送时间',
                },{
					key: 'phone',
					width:'100',
                    align:'center',
                    title: '手机号',
                },{
					key: 'waybillNo',
					width:'100',
                    align:'center',
                    title: '运单号',
                },{
					key: 'errorDesc',
					width:'500',
                    title: '发送情况',
                }
            ],
            loading: false,
            pageConfig: {
                total: 0,
                pageSize: 100,
                currentPage: 1,
            },
			dataList:[], //订单列表
			dataTotal: {},
			orderForm:{
				phone: null, //	司机手机	string	
			},
			togglePage:false, //是否显示分页
			selectedList:[],// 选中的列表
			userTypeList:[
				{
					value: '',
					label: '全部'
				},
				{
					value: 1,
					label: '货主'
				}, {
					value: 2,
					label: '司机'
				}],
		}
	},
	methods: {
        sizeChange(size) {
            this.pageConfig.currentPage = 1
            this.pageConfig.pageSize = size
            this.searchList()
        },

        currentChange(currentPage) {
            this.pageConfig.currentPage = currentPage
            this.searchList()
        },
		selectionChange(val){
			this.selectedList=val;
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			this.orderForm.waybillNo=this.orderForm.waybillNo || null
			this.orderForm.phone=this.orderForm.phone || null
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		getData(data){
            this.loading=true
            this.$server.report.wxQueryPage({
                ...data,
            }, (res) => {
				this.loading=false
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}
				
			})
		},
	},
	mounted() {
		
	}
}

</script>
<style scoped>

.driver-account {
  width: 100%;
  height: auto;
}
.data-table-box {
    height: auto;
    background: #FFF;
    padding: 8px;
	box-sizing: border-box;
	text-align: center;
}	
.data-table-warp{
	width: auto;
	margin: 0 auto;
}
.data-table{
	margin-bottom: 8px;
}
.query-setting-box-left{
    flex-grow: 0;
}
</style>
